(function () {
  if (window.__sdOfferTimerBooted) return;
  window.__sdOfferTimerBooted = true;

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  // Deterministic deadline: a pure function of the current time and the
  // configured cycle length. Every page load, on any device, at the same
  // real-world moment computes the exact same deadline — no stored state,
  // so the homepage and every product page are always perfectly in sync,
  // and once a cycle ends the next one starts automatically (it's just the
  // next multiple of the cycle length).
  function getDeadline(durationSeconds) {
    var cycleMs = durationSeconds * 1000;
    var now = Date.now();
    var cyclesElapsed = Math.floor(now / cycleMs);
    return (cyclesElapsed + 1) * cycleMs;
  }

  function renderDigits(el, totalSeconds) {
    var h = Math.floor(totalSeconds / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    var s = totalSeconds % 60;
    var str = pad(h) + pad(m) + pad(s);
    var groups = [str.slice(0, 2), str.slice(2, 4), str.slice(4, 6)];
    el.innerHTML = groups
      .map(function (pair) {
        return (
          '<span class="superdil-offer-timer__group">' +
          pair
            .split('')
            .map(function (d) {
              return '<span class="superdil-offer-timer__digit">' + d + '</span>';
            })
            .join('') +
          '</span>'
        );
      })
      .join('<span class="superdil-offer-timer__colon">:</span>');
  }

  function render() {
    var els = document.querySelectorAll('[data-superdil-timer]');
    if (!els.length) return;
    els.forEach(function (el) {
      var duration = parseInt(el.getAttribute('data-duration'), 10) || 7200;
      var deadline = getDeadline(duration);
      var diff = deadline - Date.now();
      if (diff <= 0) diff = 0;
      renderDigits(el, Math.floor(diff / 1000));
    });
  }

  render();
  setInterval(render, 1000);
})();
